var script = {
  name: 'PendoPageContent',
  inject: ['$app'],
  props: {
    tabs: {
      type: Boolean,
      default: false
    }
  },
  created() {
    this.$app.updateProperty('tabs', this.tabs);
  }
};

export { script as default };
//# sourceMappingURL=pendo-page-content.vue2.js.map
